import React, {Component, Fragment} from 'react'
import {Button, Tab, Tabs, Toast} from "react-bootstrap";
import TabContent from "./TabContent";
import ChatsPrivateContent from "./ChatsPrivateContent";
import ChatsGroupContent from "./ChatsGroupContent";
import Request from "./Request";
import Contact from "./Contact";
import CreateGroupModal from "./modals/CreateGroupModal";
import "../../../assets/sass/components/messages/messages-board.scss";

import member_avatar from '../../../assets/img/demo/player-avatar-1.png';
import group_avatar from '../../../assets/img/demo/group-avatar.svg';
import check from '../../../assets/svg/actions/icn-check-white-16px.svg';

import Tools from "../../../Tools";
import AddParticipantsModal from "./modals/AddParticipantsModal";
import GroupInfoModal from "./modals/GroupInfoModal";
import classes from "classnames";
import Icon from "../Icon";
import DropAndCropModal from "../images/DropAndCropModal";

class MessagesBoard extends Component {

    chatsPrivateContent = React.createRef();
    chatsGroupContent = React.createRef();

    participants = [
        { name: "ahmad", avatar: member_avatar },
        { name: "ahmad", avatar: member_avatar },
        { name: "ahmad", avatar: member_avatar },
        { name: "ahmad", avatar: member_avatar },
    ];

    discussion = [
        { type: "receive", avatar: member_avatar, name: "Ahmad",  message: "After evaluating the report I think seem to be good at front"},
        { type: "send", avatar: member_avatar, name: "Ahmad", message: "Hi guys here sharing the evaluation report please put your comments"},
        { type: "receive", avatar: member_avatar, name: "Ahmad", message: "After evaluating the report I think seem to be good at front"},
        { type: "send", avatar: member_avatar, name: "Ahmad", message: "Yeh Thats right"},
    ];

    state = {
        createGroupModalShow: false,
        addParticipantsModalShow: false,
        groupInfoModalShow: false,

        toast: {
            show: false,
            message: "2 Participants Added",
        },

        new_connection: false,

        live_group: "",

        discussions: {
            chats: {
                name: "Nathan Warren",
                info: "Club Manager | Dream Football Club",
                participants: [
                    this.participants[0]
                ],
                discussion: this.discussion
            },
            groups: {
                name: "Group Name 1",
                info: "Create by You | 12/31/2019",
                participants: this.participants,
                discussion: this.discussion
            },
            groups_test: {
                name: "Group Test 1",
                info: "Create by You | Today",
                participants: [
                    this.participants[0]
                ],
                discussion: []
            }
        },

        roles: [
            { key: 0, active: true},
            { key: 1, title: "Scouts", active: false },
            { key: 2, title: "Player Agents", active: false },
            { key: 3, title: "Coaches", active: false },
            { key: 4, title: "Club Managers", active: false },
            { key: 5, title: "Players", active: false },
            { key: 6, title: "Others", active: false }
        ],
        members: {
            chats: [
                { key: 0, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: true },
                { key: 1, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false},
                { key: 2, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false},
                { key: 3, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false},
                { key: 4, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false},
                { key: 5, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false},
                { key: 6, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false},
                { key: 7, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false},
                { key: 8, avatar: member_avatar, name: "Nathan Warren", excerpt: "You : Hi there i have shared the reports wth you. Please check it", date_of_publish: "Today", active: false}
            ],
            groups: [
                { key: 0, avatar: group_avatar, name: "Group Name 1", excerpt: "Ann : I Think that is true the player is awsome in the passing.",  date_of_publish: "Today", active: true },
                { key: 1, avatar: group_avatar, name: "Group Name 2", excerpt: "Ann : I Think that is true the player is awsome in the passing.",  date_of_publish: "Today", active: false },
                { key: 2, avatar: group_avatar, name: "Group Name 3", excerpt: "Ann : I Think that is true the player is awsome in the passing.",  date_of_publish: "Today", active: false },
                { key: 3, avatar: group_avatar, name: "Group Name 4", excerpt: "Ann : I Think that is true the player is awsome in the passing.",  date_of_publish: "Today", active: false },
            ],
            request_sent: [
                { key: 0, avatar: member_avatar, name: "Gregory Bell", excerpt: "Scout | Canberry Football Club",  date_of_publish: "Today",status: 'resend', active: true },
                { key: 1, avatar: member_avatar, name: "Beth Black", excerpt: "Scout | Canberry Football Club",  date_of_publish: "Today",status: 'resend', active: false },
                { key: 2, avatar: member_avatar, name: "Gregory Bell", excerpt: "Scout | Canberry Football Club",  date_of_publish: "Today",status: 'resend', active: false },
                { key: 3, avatar: member_avatar, name: "Ann Flores", excerpt: "Scout | Canberry Football Club",  date_of_publish: "Today",status: 'resend', active: false }
            ],
            request_new_connection: Array.from(Array(25).keys())
                .map((item, index) => ({
                    key: Tools.generateToken(5),
                    avatar: member_avatar,
                    name: 'Calvin Cooper',
                    excerpt: 'Scout | Canberry Football Club',
                    date_of_publish: "Today",
                    active: index == 0,
                    status: 'send'
                })),
            request_received: [
                { key: 0, avatar: member_avatar, name: "Gregory Bell", excerpt: "Scout | Canberry Football Club", date_of_publish: "Today", active: true },
                { key: 1, avatar: member_avatar, name: "Beth Black", excerpt: "Scout | Canberry Football Club", date_of_publish: "Yesterday", active: false },
                { key: 2, avatar: member_avatar, name: "Gregory Bell", excerpt: "Scout | Canberry Football Club", date_of_publish: "12/23/2019", active: false },
                { key: 3, avatar: member_avatar, name: "Ann Flores", excerpt: "Scout | Canberry Football Club", date_of_publish: "12/23/2019", active: false }
            ],
            contacts: [
                { key: 0, avatar: member_avatar, name: "Gregory Bell", excerpt: "Scout | Canberry Football Club", active: true },
                { key: 1, avatar: member_avatar, name: "Beth Black", excerpt: "Scout | Canberry Football Club", active: false },
                { key: 2, avatar: member_avatar, name: "Gregory Bell", excerpt: "Scout | Canberry Football Club", active: false },
                { key: 3, avatar: member_avatar, name: "Ann Flores", excerpt: "Scout | Canberry Football Club", active: false }
            ],
        },
    }

    handleCreateGroupModalClose = () => {
        this.setState({
            createGroupModalShow: false
        })
    }

    handleAddParticipantsModalClose = () => {
        this.setState({
            addParticipantsModalShow: false
        })
    }

    handleGroupInfoModalClose = () => {
        this.setState({
            groupInfoModalShow: false
        })
    }

    onAddParticipantsClick = () => {
        this.setState({
            addParticipantsModalShow: true
        })
    }

    showGroupInfoModal = () => {
        this.setState({
            groupInfoModalShow: true
        })
    }

    handleCreateGroupModalOpen = () => {
        this.setState({
            createGroupModalShow: true
        })
    }

    handleMakeNewConnection = () => {
        this.setState({
            new_connection: true
        });
    }

    handleCloseNewConnection = () => {
        this.setState({
            new_connection: false
        });
    }

    memberHeaderExtraContent = () => {
        return (
            <div className="members-section-header">
                <h3>Make New Connection</h3>
                <Button variant="link" onClick={this.handleCloseNewConnection}>Close</Button>
            </div>
        )
    }

    roleClick = (event, key, name) => {
        var roles = this.state.roles.map((item) => {
            item.active = item.key == key;
            return item;
        })

        this.setState({
            roles: roles
        })
    }

    memberClick = (event, key, name) => {
        var member = this.state.members[name].filter((item) => {
            return item.key == key;
        });
        var members = this.state.members[name].map((item) => {
            item.active = item.key == key;
            return item;
        })

        this.setState({
            members: Object.assign(this.state.members, { [name]: members } ),
            live_group: member[0].status == "test" ? "group_test" : ""
        })
    }

    newConnectionMemberClick = (event, key, name) => {
        var members = this.state.members.request_new_connection.map((item) => {
            item.active = item.key == key;
            return item;
        })

        this.setState({
            members: Object.assign(this.state.members, { request_new_connection: members } ),
        })
    }

    onChatBubbleSubmit = (event, name, data) => {
        if(data.message || data.attachment.name)
            this.setState({
                discussions: Object.assign(this.state.discussions, {
                    [name]: Object.assign(this.state.discussions[name], {
                        discussion : [
                            ...this.state.discussions[name].discussion,
                            { type: 'send', avatar: member_avatar, name: "Ahmad", ...data}
                        ]
                    })
                })
            }, function () {
                var room = name == 'chats' ? this.chatsPrivateContent : this.chatsGroupContent;
                room.current.shadowScrollbarsRef.current.refs.scrollbars.scrollTop(room.current.chatMessagesAreaRef.current.getBoundingClientRect().height);
            });
    }

    onCreateGroupSubmit = (event, group_name) => {
        this.setState({
            members: {
                ...this.state.members,
                groups: [
                    { key: Tools.generateToken(8), avatar: group_avatar, name: group_name, excerpt: "Ann : I Think that is true the player is awsome in the passing.",  date_of_publish: "Today", active: true, status: 'test' },
                    ...this.state.members.groups.filter((item) => {item.active = false; return item})
                ]
            },
            createGroupModalShow: false,
            live_group: "group_test",
        })
    }

    onAddParticipantsSubmit = (event, participants) => {
        var participants = participants.map(item => {
            return { name: "ahmad", avatar: member_avatar };
        })
        this.setState({
            discussions: Object.assign(this.state.discussions, {
                groups_test: Object.assign(this.state.discussions.groups_test, {
                    participants: [
                        ...this.state.discussions.groups_test.participants,
                        ...participants
                    ]
                })
            })
        }, function () {
            this.setState({
                addParticipantsModalShow: false,
                toast: {
                    show: true,
                    message: `${participants.length} Participants Added`,
                },
            })
        })
    }

    toastShow = () => {
        this.setState({
            toast: {
                ...this.state.toast,
                show: false,
            },
        })
    }

    toastHtml = () => {
        return (
            <div className="toast-global">
                <Toast show={this.state.toast.show} onClose={() => this.toastShow(false)}  delay={3000} autohide>
                    <Toast.Body>{this.state.toast.message}</Toast.Body>
                </Toast>
            </div>
        );
    }

    getRequestStatus = () => {
        return this.state.new_connection
            ? this.state.members.request_new_connection.filter(item => item.active == true)[0]
            : this.state.members.request_sent.filter(item => item.active == true)[0]
    }

    onSendRequestClick = () => {
        var members = JSON.parse(JSON.stringify(this.state.members.request_new_connection)).map((item) => {
            if(item.active)
                item.status = 'pending';
            return item;
        })
        var requestedMembers = JSON.parse(JSON.stringify(this.state.members.request_new_connection)).slice().filter((item) => {
            return item.active == true;
        }).map((item) => {
            return Object.assign(item, { active: false, status: 'resend' });
        })

        this.setState({
            members: Object.assign(this.state.members, {
                request_sent: [
                    ...this.state.members.request_sent,
                    ...requestedMembers
                ],
                request_new_connection: members
            }),
        }, function () {
            this.setState({
                toast: {
                    show: true,
                    message: (
                        <Fragment>
                            <Icon svg={check} className="icon"/>
                            <span>Connection request Sent</span>
                        </Fragment>
                    ),
                },
            })
        })
    }

    messagesBoard = () => {
        return (
            <div className="messages-board">
                <Tabs defaultActiveKey="chats" id="messages-board-tabs" transition={false} unmountOnExit={true}>
                    <Tab eventKey="chats" title="Chats">
                        <TabContent
                            name="chats"
                            defaultRoleList="All Chats"
                            roleList={this.state.roles}
                            roleClick={this.roleClick}
                            memberSearchPlaceholder="Search chat , Person name"
                            memberList={this.state.members.chats}
                            memberClick={this.memberClick}
                        >
                            <ChatsPrivateContent ref={this.chatsPrivateContent} name="chats" type="private" data={this.state.discussions.chats} onChatBubbleSubmit={this.onChatBubbleSubmit} onChatBubbleAttachmentSubmit={this.onChatBubbleSubmit}></ChatsPrivateContent>
                        </TabContent>
                    </Tab>
                    <Tab eventKey="discussions" title="Discussions">
                        <TabContent
                            name="groups"
                            defaultRoleList="All Discussions"
                            roleList={this.state.roles}
                            roleClick={this.roleClick}
                            memberSearchPlaceholder="Search group name"
                            memberButtonText="Create New Group"
                            memberButtonClick={this.handleCreateGroupModalOpen}
                            memberList={this.state.members.groups}
                            memberClick={this.memberClick}
                        >
                            <ChatsGroupContent ref={this.chatsGroupContent} name="groups" type="group" data={this.state.live_group == "group_test" ? this.state.discussions.groups_test : this.state.discussions.groups} onChatBubbleSubmit={this.onChatBubbleSubmit} onChatBubbleAttachmentSubmit={this.onChatBubbleSubmit} onAddParticipantsClick={this.onAddParticipantsClick} showGroupInfoModal={this.showGroupInfoModal}></ChatsGroupContent>
                            <CreateGroupModal show={this.state.createGroupModalShow} onHide={this.handleCreateGroupModalClose} onSubmit={this.onCreateGroupSubmit}/>
                            <AddParticipantsModal show={this.state.addParticipantsModalShow} onHide={this.handleAddParticipantsModalClose} onSubmit={this.onAddParticipantsSubmit}/>
                            <GroupInfoModal show={this.state.groupInfoModalShow} onHide={this.handleGroupInfoModalClose}></GroupInfoModal>
                        </TabContent>
                    </Tab>
                    <Tab eventKey="request-sent" title="Request Sent">
                        <TabContent
                            name="request_sent"
                            className={classes("request-sent member-p-gray", this.state.new_connection ? "request-new-connection" : "")}
                            defaultRoleList="All Requests"
                            roleList={this.state.roles}
                            roleClick={this.roleClick}
                            memberHeaderExtraContent={this.state.new_connection ? this.memberHeaderExtraContent : null}
                            memberSearchPlaceholder={this.state.new_connection ? "Search Names" : "Search requests sent"}
                            memberButtonText={this.state.new_connection ? null : "Make New Connection"}
                            memberButtonClick={this.state.new_connection ? null : this.handleMakeNewConnection}
                            memberList={this.state.new_connection ? this.state.members.request_new_connection : this.state.members.request_sent}
                            memberClick={this.state.new_connection ? this.newConnectionMemberClick : this.memberClick}
                        >
                            <Request type="send" status={ this.getRequestStatus().status } onSendRequestClick={this.onSendRequestClick}></Request>
                        </TabContent>
                    </Tab>
                    <Tab eventKey="request-received" title="Request Received">
                        <TabContent
                            name="request_received"
                            className="member-p-gray"
                            defaultRoleList="All Requests"
                            roleList={this.state.roles}
                            roleClick={this.roleClick}
                            memberSearchPlaceholder="Search requests received"
                            memberList={this.state.members.request_received}
                            memberClick={this.memberClick}
                        >
                            <Request type="received"></Request>
                        </TabContent>
                    </Tab>
                    <Tab eventKey="contacts" title="Contacts">
                        <TabContent
                            name="contacts"
                            className="member-p-gray"
                            defaultRoleList="All Contacts"
                            roleList={this.state.roles}
                            roleClick={this.roleClick}
                            memberSearchPlaceholder="Search requests sent"
                            memberList={this.state.members.contacts}
                            memberClick={this.memberClick}
                        >
                            <Contact></Contact>
                        </TabContent>
                    </Tab>
                </Tabs>
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                {this.messagesBoard()}
                {this.toastHtml()}
            </Fragment>
        )
    }
}

export default MessagesBoard;